export default "__VITE_ASSET__Cc__QbVx__"